import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capacidadeFormater' })
export class CapacidadeFormaterPipe implements PipeTransform {

  transform(value: any, sufix: string, casasDecimais = 2): string {
    value = value || 0;
    return Number(value).toFixed(casasDecimais).concat(' ').concat(sufix);
  }
}
